module.exports = __webpack_public_path__ + "img/switzerland-respiratory-diseases-female.14f36e89.png";